import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  BarcodeExtractionApi,
  type BarcodeExtractionRuleUpsertRequest,
} from '@ulysses-inc/harami_api_client'
import { useSnackbar } from 'src/components/snackbar/useSnackbar'
import { getLobsterApiErrorDetail } from 'src/features/labelMaster/api/getLobsterApiErrorDetail'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { barcodeSettingQueryKeys } from './queryKeys'

export const useSaveBarcodeExtractionRule = () => {
  const queryClient = useQueryClient()
  const { showSuccessSnackbar, showErrorSnackbar } = useSnackbar()

  return useMutation({
    mutationFn: async (
      rule: BarcodeExtractionRuleUpsertRequest | undefined,
    ) => {
      const api = baseClient.getApi(BarcodeExtractionApi)
      if (rule === undefined) {
        await api.deleteBarcodeExtractionRule()
        return
      }
      await api.upsertBarcodeExtractionRule({
        barcodeExtractionRuleUpsertRequest: rule,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: barcodeSettingQueryKeys.rule })
      showSuccessSnackbar('保存しました')
    },
    onError: async error => {
      const detail = await getLobsterApiErrorDetail(error)
      showErrorSnackbar(detail ?? '保存に失敗しました')
    },
  })
}
